import { ChartPie } from "@phosphor-icons/react";
import clsx from "clsx";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";
import type { WorkspaceAccount } from "common/types";

import useAccountSSI from "../../datahooks/useAccountSSI";

interface AccountSsiTagProps {
  account: WorkspaceAccount;
  isTag: boolean;
}

export default function AccountSsiTag({ account, isTag }: AccountSsiTagProps) {
  const { accountSSI, isLoadingAccountSSI } = useAccountSSI(account);

  if (isLoadingAccountSSI) {
    return (
      <Skeleton
        className={clsx("rounded-md", isTag ? "h-5 w-16" : "h-4 w-14")}
      />
    );
  }

  if (!accountSSI) return isTag ? null : "-";

  const textValue = `${Math.round(accountSSI.overall)}/100%`;

  if (isTag) {
    return (
      <Tag variant="tertiary" leftIcon={<ChartPie weight="fill" />} size="sm">
        {textValue}
      </Tag>
    );
  }

  return <span className="text-button-xs">{textValue}</span>;
}
